<div class="compliance-dashboard">
    @if (trainings && trainings.length>0) {
    <div class="ui cards">
        <div class="rowtitle" translate>
            Training Courses
        </div>
        @for (t of trainings; track t) {
        <div class="ui card trainingbox" [class.clickable]="t.status!='expired' && t.status!='complete'"
            (click)="goTraining(t)">
            <div class="content">
                <div class="header">
                    <div>{{t.name}} </div>
                    <div>&gt;</div>
                </div>
                <p><span translate>Assigned date</span>: <b>{{t.effectiveDate | date:'shortDate'}}</b></p>
                @if (t.expireDate) {
                <p><span translate>Expiration date</span>: <b>{{t.expireDate | date:'shortDate'}}</b></p>
                }
                @if (t.status=='complete') {
                <p><span translate>Completion date</span>: <b>{{t.completionDate | date:'shortDate'}}</b></p>
                }
            </div>
            <div class="ui bottom attached">
                <itc-tag [size]="'large'" (clicked)="goTraining(t)" [status]="t.status">{{t.status |
                    translate}}</itc-tag>
            </div>
        </div>
        }
    </div>
    }

    @if (policies && policies.length>0) {
    <div class="ui cards">
        <div class="rowtitle" translate>
            Policies
        </div>
        @for (p of policies; track p) {
        <div class="ui card trainingbox clickable" (click)="showPolicy(p)">
            <div class="content">
                <div class="header">
                    <div truncateText [truncateLines]="2">{{p.name}}</div>
                    <div>&gt;</div>
                </div>
                <p><span translate>Assigned date</span>: <b>{{p.effectiveDate | date:'shortDate'}}</b></p>
                <p><span translate>Expiration date</span>: <b>{{p.expireDate | date:'shortDate'}}</b></p>
                @if (p.acceptance) {
                <p><span translate>Completion date</span>: <b>{{p.acceptance.AcceptedDate | date:'shortDate'}}</b></p>
                }
            </div>
            <div class="ui bottom attached">
                <itc-tag [size]="'large'" [status]="p.status">{{'policystatus.'+p.status | translate}}</itc-tag>
            </div>
        </div>
        }
    </div>
    }

    <div class="ui modal policy-dialog">
        @if (selectedPolicy) {
        <i class="close icon"></i>
        <div class="header" truncateText>
            {{selectedPolicy.name}}
        </div>
        <div class="content">
            <div class="description" [innerHtml]="selectedPolicy.description | i18ntexttranslate | nl2br">
            </div>
            <ul class="reflinks">
                @for (r of selectedPolicy.refLinks; track r) {
                <li>
                    <a target="_blank" [href]="r.Url">{{r.Label}}</a>
                </li>
                }
            </ul>
        </div>
        @if (selectedPolicy.status!='expired') {
        <div class="actions">
            <itc-tag [size]="'large'"
                [status]="selectedPolicy.status=='rejected' ? 'rejected-button' : 'default-button'"
                (clicked)="rejectPolicy()" translate>
                Reject
            </itc-tag>
            <itc-tag [size]="'large'"
                [status]="selectedPolicy.status=='accepted' ? 'accepted-button' : 'default-button'"
                (clicked)="acceptPolicy()" translate>
                Accept
            </itc-tag>
        </div>
        }
        @if (selectedPolicy.status=='expired') {
        <div class="actions">
            <itc-tag [size]="'large'" (clicked)="closePolicy()" [status]="'default-button'" translate>
                Close
            </itc-tag>
        </div>
        }
        }
    </div>

    <div class="ui modal training-alert">
        @if (selectedTraining) {
        <i class="close icon"></i>
        <div class="header">
            {{selectedTraining.name}}
        </div>
        <div class="content">
            <div class="description">
                <span translate>training unavailable</span>
            </div>
        </div>
        <div class="actions">
            <itc-tag [size]="'large'" (clicked)="closeTrainingAlert()" [status]="'default-button'" translate>
                Close
            </itc-tag>
        </div>
        }
    </div>
</div>